import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("vehicle/index"),
  
  store: (userData) => clientAuth.post('vehicle/store', { json: userData }),
  

  show:(id)=>clientAuth.get('vehicle/show/'+id),

  update:(id,userData)=>clientAuth.post('vehicle/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`vehicle/destroy/${id}`),
};